import { render, staticRenderFns } from "./Decoration1.vue?vue&type=template&id=5df982ce&scoped=true"
import script from "./Decoration1.vue?vue&type=script&lang=js"
export * from "./Decoration1.vue?vue&type=script&lang=js"
import style0 from "./Decoration1.vue?vue&type=style&index=0&id=5df982ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df982ce",
  null
  
)

export default component.exports